<template>
<div>
    <v-container fluid>
       <v-row justify="center">
         <v-col align="center">
            <h1 class="font-weight-light">SpruchList</h1>
            <p><small>Version 1.0 (Lemmastrecke A-H)</small></p>
            <p> Die erste online abruf- und durchsuchbare Häufigkeitsliste deutscher Sprichwörter und Sprüche<br/>
               basierend auf quantitativ-qualitativen Erhebungen im Deutschen Referenzkorpus (DeReKo). <br/>
             <About></About>
            </p>
        </v-col>
      </v-row>
<v-row>
  <v-col>
       <v-radio-group
            v-model="filterData"
            mandatory
          >
            <v-radio
              color="black"
              label="Zeige alle Einträge"
              value="alle"
            ></v-radio>
            <v-radio
              color="black"
              label="Zeige nur Einträge, die Teil des OWID-Sprichwörterbuchs sind"
              value="swb"
            ></v-radio>
            <v-radio
              color="black"
              label="Zeige nur Einträge, die nicht Teil des OWID-Sprichwörterbuchs sind"
              value="notswb"
            ></v-radio>
          </v-radio-group>

    </v-col>
    </v-row>
<v-row>
  <v-col>
     <v-tabs>
        <v-tab>
          
          Tabelle
        </v-tab>
        <v-tab>
          
          Visualisierungen
        </v-tab>

        <v-tab-item>
 <!--       <v-container>
 <v-row>
  <v-col> -->
          <v-card>
              <v-card-title>
     


              <v-spacer></v-spacer>
              <v-btn  small @click="download()">Tabelle herunterladen (csv)</v-btn>
              &nbsp;
      <AboutCSV></AboutCSV>
                </v-card-title>
              <v-card-text >
                <p>Durch Klick auf das Pfeilsymbol am linken Rand können die Suchanfragen angezeigt werden, die zu den engen und weiten Frequenzen führen.  </p>
            <v-data-table 
                :headers="dataheaders"
          :items="spruchdata"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search" 
          item-key="sprichw"
          show-expand
          :items-per-page="10"
          :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, 250, -1] }"
          class="elevation-1"
          >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{spruchdata.length}} Sprichwörter</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field     
              v-model="search"
              append-icon="mdi-magnify"
              label="Tabelle durchsuchen"
              single-line
              hide-details
            ></v-text-field>
            </v-toolbar>
          </template>

          <!-- Button that triggers KWICDialog --> 
            <template v-slot:item.kwics="{ item }">
             <KwicDialogLeftAlign :fileName="item.kwics" :sprichwortname="item.sprichw"> </KwicDialogLeftAlign>
          </template>

          <!-- Button with link to Sprichwörterbuch-->
          <template v-slot:item.swb="{ item }">
            <v-btn
        v-if="item.swb != '_'"
          color="grey darken-4"
          dark
          small
          :href="item.swb"
          target="_blank"
        >
          Artikel
        </v-btn>
          </template>

          

          <template v-slot:expanded-item="{item}">
          <td></td>
          <td></td>
            <td colspan="2">
              <b>Enge Suchanfrage:</b><br/> {{ item.such_eng }}
            </td>
            <td colspan="2" >
              <b>Weite Suchanfrage:</b><br/> {{ item.such_weit }}
            </td>
          </template>
          </v-data-table>
      </v-card-text>
        </v-card >
<!-- </v-col>
</v-row>
</v-container> -->

      </v-tab-item>

      <v-tab-item>

<v-container>
  <v-row>
      <v-col>
       <SpruchScatterplotRang :spruchdata="spruchdata"></SpruchScatterplotRang>
       </v-col>
    </v-row>


      <v-row>
      <v-col>
       <SpruchHistogramm :spruchdata="spruchdata"></SpruchHistogramm>
       </v-col>
    </v-row>


  
</v-container>
</v-tab-item>
</v-tabs>
 </v-col>
    </v-row>

</v-container>

 <v-footer color="grey darken-4">
  <v-row justify="center"
      no-gutters>
    <v-col style="color:white" class="text-center">
      Letzte Aktualisierung: 2022-12-16 
    </v-col>

    <v-col class="text-center">
      <a style="color:white" href="https://www.ids-mannheim.de/lexik/uwv/">Arbeitsbereich "Usuelle Wortverbindungen"</a> — 
      <a style="color:white" href="https://www.owid.de/wb/owid/impressum.html">Impressum</a> —
      <a style="color:white" href="https://www.owid.de/wb/owid/privacy.html">Datenschutzhinweise</a>
    </v-col>
    </v-row>
  </v-footer>


</div>
</template>

<script>
import spruchlistJson from '../assets/spruchlist.json'
import Papa from "papaparse";
import SpruchScatterplotRang from './SpruchScatterplotRang'
import SpruchHistogramm from './SpruchHistogramm.vue';
import KwicDialogLeftAlign from './KwicDialogLeftAlign.vue';
import AboutCSV from './AboutCSV.vue';
import About from './AboutTabs.vue';


  export default {
    name: 'Index',
    components: { SpruchHistogramm, SpruchScatterplotRang, KwicDialogLeftAlign, AboutCSV, About},      

    data: () => ({
        tabledata: spruchlistJson,
        dataheaders: [
            {text: 'Sprichwort', value: 'sprichw'},
            {text: 'Frequenz (eng)', value: 'freq_eng'},
             {text: 'Rang (eng)', value: 'rang_eng'},
            //{text: 'Suchanfrage (eng)', value: 'such_eng'},
            {text: 'Frequenz (weit)', value: 'freq_weit'},
              {text: 'Rang (weit)', value: 'rang_weit'},
            //{text: 'Suchanfrage (weit)', value: 'such_weit'},
            {text: 'Ratio eng/weit', value: 'ratio'},
            {text: 'Sprichwörterbuch', value: 'swb'},
             {text: 'KWICs', value: 'kwics'},
            
            ],
        expanded: [],
        singleExpand: false,
        search: "",
        onlySWB: false,
        filterData: "alle",
        
    }),
    methods: {
         download() {
            // credit: https://www.bitdegree.org/learn/javascript-download
            let text = Papa.unparse(this.spruchdata);
            let filename = 'spruchlist.csv';
            let element = document.createElement('a');
            element.setAttribute('href', 'data:application/csv;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);     
        },

    },
    computed: {
        spruchdata() {
          console.log(this.filterData);
          var spruchdata = [];
          if (this.filterData == "swb") {
            for (let index=0; index < this.tabledata.length; index++) {
               console.log(this.tabledata[index].swb);
              if (this.tabledata[index].swb != "_") {
                spruchdata.push(this.tabledata[index]);
              }   
            }
          }
          else if (this.filterData == "notswb") {
            for (let index=0; index < this.tabledata.length; index++) {
              if (this.tabledata[index].swb == "_") {
                spruchdata.push(this.tabledata[index]);
              }   
            }
          }
          else {
            spruchdata = this.tabledata;
          }
          return spruchdata;
        }
    },
    mounted() {
      const queries = new URLSearchParams(window.location.search);
      var search = "";
      if (queries.has("search")) {
        search = queries.get("search");
      }
      this.search = search;
    }
  }
</script>
